import gql from "graphql-tag";
import { GameAccountFragment } from "./game-account.fragment";

export const RebateItemFragment = gql`
  fragment RebateItem on RebateItem {
    id
    player {
      username
      name
      id
      serialNo
      phoneNo
    }
    totalDeposit
    totalWithdrawal
    totalBonus
    rebatePercentage
    rebateAmount
    releasedAt
    lastGameAccount {
      ...GameAccountInfo
    }
  }
  ${GameAccountFragment}
`;
